import {
  formatCurrency,
  formatNumber,
} from "../../../../../components/common/Converter";
export const shouldRenderInput = (label, selectedTypes, item) => {
  // console.log("LABELLLLLLL", label);
  // console.log("SELECT6EDDD TYPESSS", selectedTypes);
  let { payItems, jobTypeVal } = selectedTypes || {};

  if (!payItems || !jobTypeVal) {
    const segments = item?.payrollType?.split(" - ");
    jobTypeVal = segments?.[1];
    payItems = segments?.[2];
    // console.log("SEGMENTSSS", segments);
  }

  const isNotAddendumBackPay = payItems !== "Addendum Back-Pay";
  const isJobOrder = jobTypeVal === "Job Order";
  const isAddendum = payItems === "Addendum Payroll";
  const isSalary = payItems === "Salary";
  const isNotBackPay = payItems !== "Back-Pay";
  const isNotInitalBackPay = payItems !== "Initial AP";
  const isNotLastBackPay = payItems !== "Last AP";
  const isJoBackPay = jobTypeVal === "Job Order" && payItems === "Last";

  const isSpecialLabel = ["overpayment", "flagRaising", "noOfDays"].includes(
    label
  );

  return (
    (isNotAddendumBackPay &&
      (label === "overpaymentBasic" || label === "overpaymentPeraAda")) ||
    (isSpecialLabel &&
      !isJobOrder &&
      !isAddendum &&
      isNotBackPay &&
      isNotInitalBackPay &&
      isNotLastBackPay) ||
    (isSpecialLabel && isJobOrder && isSalary) ||
    ((label === "OfDutyForCiaMciaBinocRangeTo1519" ||
      label === "excessAirportDuties") &&
      isNotBackPay &&
      isNotInitalBackPay &&
      isNotLastBackPay &&
      !isJoBackPay) ||
    (label === "tax" &&
      (payItems === "Initial" ||
        payItems === "Last" ||
        payItems === "SalaryDiffBasic")) ||
    (label === "tax" &&
      (payItems === "Initial AP" || payItems === "Last AP")) ||
    (label === "pagibig" && payItems === "Last") ||
    (label === "apRate" && isNotInitalBackPay && isNotLastBackPay) ||
    (label === "2" &&
      jobTypeVal === "Job Order" &&
      (payItems === "Initial" || payItems === "Last")) ||
    // (label === "phic" && (payItems === "Initial" || payItems === "Last")) ||
    label === "myDiff" ||
    label === "yeDiff" ||
    label === "gratuityPay"
  );
};

export const getValueOrDefault = (value, label, item) => {
  const defaultLabels = ["OfDutyForCiaMciaBinocRangeTo1519", "noOfDays"];

  if (value !== undefined && value !== 0 && value !== "") {
    return formatNumber(value.toString());
  }

  if (
    item &&
    label in item &&
    item[label] !== undefined &&
    item[label] !== 0 &&
    item[label] !== ""
  ) {
    return formatNumber(item[label].toString());
  }

  return defaultLabels.includes(label) ? 22 : "";
};

export const shouldRenderDaterange = (label, selectedTypes) => {
  const { payItems } = selectedTypes || {};
  return (
    label === "date"
    // (label === "OfDutyForCiaMciaBinocRangeTo1519" && payItems === "Back-Pay")
  );
};

export const shouldBeFormatted = (label, value) => {
  const excludedLabels = [
    "employeeNumber",
    "daysToBeDeducted",
    "halfDaysToBeDeducted",
    "minsToBeDeducted",
    "minsDeducted",
    "minutesToBeDeducted",
    "gsisInsuredDays",
    "daysInAMonth",
    "totalDaysDuty",
    "noOfDuties",
    "latesUtPerMinute3",
    "latesUtPerMinute",
    "latesUtPerMinute2",
    "abs",
    "abs2",
    "OfDays1Month",
    "days",
    "mins",
    "inService",
    "daysForGsis",
    "holWkendsOff",
    "noOfLatesIncurred",
    "acctNo",
    "noOfDaysPresent",
    "daysDeducted",
    "halfDays",
  ];

  return (
    typeof value === "number" &&
    isFinite(value) &&
    !excludedLabels.includes(label)
  );
};

export const shouldRenderMultipleInputs = (label, selectedTypes) => {
  const { payItems, jobTypeVal, payrollTypes } = selectedTypes || {};

  const validLabels = [
    "overpaymentBasic",
    "overpaymentPeraAda",
    "tax",
    "overpayment",
    "flagRaising",
    "noOfDays",
    "3",
    "2",
    "5",
    "10",
    "pagibig",
    "phic",
  ];
  const otherCases = [
    "OfDutyForCiaMciaBinocRangeTo1519",
    "overpayment",
    "flagRaising",
    "apRate",
    "basicSalary",
    // "tax",
    "excessAirportDuties",
  ];

  const isAddendumBackPay = payItems === "Addendum Back-Pay";
  const isJobOrderAddendum =
    jobTypeVal === "Job Order" && payItems === "Addendum Payroll";
  const isAp = payrollTypes === "AP";
  const isInitialBackPay = payItems === "Initial AP";
  const isLastBackPay = payItems === "Last AP";
  const isJOBackPay = jobTypeVal === "Job Order" && payItems === "Last";

  return (
    ((isAddendumBackPay || isJobOrderAddendum) &&
      validLabels.includes(label)) ||
    (otherCases.includes(label) && isAp) ||
    ((isInitialBackPay || isLastBackPay || isJOBackPay) &&
      otherCases.includes(label))
  );
};

export const shouldFormatArray = (label, value) => {
  // console.log("LABELL", label);
  const excludedLabels = [
    "daysEarned",
    "noOfLatesIncurred",
    "noOfDaysPresent",
    "halfDaysToBeDeducted",
    "daysToBeDeducted",
    "minutesToBeDeducted",
    "minsToBeDeducted",
    "minsDeducted",
    "daysInAMonth",
    "gsisInsuredDays",
    "employeeNumber",
    "totalDaysDuty",
    "noOfDuties",
    "latesUtPerMinute3",
    "latesUtPerMinute",
    "latesUtPerMinute2",
    "abs",
    "abs2",
    "OfDays1Month",
    "days",
    "mins",
    "inService",
    "daysForGsis",
    "holWkendsOff",
    "noOfLatesIncurred",
    "acctNo",
    "noOfDaysPresent",
    "daysDeducted",
    "halfDays",
  ];

  return (
    typeof value === "number" &&
    isFinite(value) &&
    !excludedLabels.includes(label)
  );
};
